import { CommentAttributor } from './Comment';

class Annotation extends CommentAttributor {
  constructor(attrName = 'annotation', keyName = 'annotation') {
    super(attrName, keyName);
  }
}

export default new Annotation();
